import React, { useState, useRef, useEffect } from 'react';
import '../../styles/NdaBlock.css';

const NDA_TEXT = `ACCORD DE CONFIDENTIALITÉ — STARTUP VILLAGE

En signant cet accord, le visiteur s'engage à :

1. Ne pas divulguer, reproduire ou transmettre à des tiers toute information confidentielle obtenue lors de sa visite dans les locaux de Startup Village.

2. Considérer comme confidentielles toutes les informations relatives aux entreprises résidentes, leurs projets, technologies, stratégies commerciales, données financières et tout autre élément non public.

3. Ne pas photographier, filmer ou enregistrer les espaces de travail, les écrans, les documents ou les conversations sans autorisation explicite.

4. Utiliser les informations obtenues uniquement dans le cadre de l'objet déclaré de la visite.

5. Restituer tout document ou support d'information fourni pendant la visite.

Cet engagement de confidentialité reste en vigueur pendant une durée de deux (2) ans à compter de la date de signature.

Le non-respect de ces engagements pourra donner lieu à des poursuites judiciaires conformément à la législation en vigueur.

Version: ${process.env.REACT_APP_NDA_VERSION || 'v1.0'}
`;

export default function NdaBlock({ onAccept, onDecline }) {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setHasScrolledToBottom(true);
      }
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAccept = () => {
    setAccepted(true);
    onAccept({
      signedAt: new Date().toISOString(),
      ndaVersion: process.env.REACT_APP_NDA_VERSION || 'v1.0',
    });
  };

  return (
    <div className="nda-block">
      <h2>Accord de Confidentialité</h2>
      <p className="nda-instruction">Veuillez lire l'accord en entier avant de l'accepter.</p>

      <div className="nda-text-container" ref={scrollRef}>
        <pre className="nda-text">{NDA_TEXT}</pre>
      </div>

      {!hasScrolledToBottom && (
        <p className="nda-scroll-hint">↓ Faites défiler jusqu'en bas pour activer l'acceptation</p>
      )}

      <div className="nda-actions">
        <label className={`nda-checkbox-label ${!hasScrolledToBottom ? 'disabled' : ''}`}>
          <input
            type="checkbox"
            checked={accepted}
            disabled={!hasScrolledToBottom}
            onChange={handleAccept}
          />
          J'ai lu et j'accepte l'accord de confidentialité
        </label>

        <div className="nda-buttons">
          <button
            className="btn btn-secondary"
            onClick={onDecline}
            type="button"
          >
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
}
